import React from 'react';
import PropTypes from 'prop-types';
import SearchBar from './SearchBar';
import SocialChatMenu from './SocialChatMenu';
import SocialNotificationsMenu from './SocialNotificationsMenu';
import SocialUserMenu from './SocialUserMenu';
import WMIconButton from '@workmarket/front-end-components/dist/WMIconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import utils from '../utilities';

const RightMenuGroup = ({ support, user, useZendesk, useZoomChat, hideSearchBar, hideNotifications }) => (
	<div>
		<div>
			{ !hideSearchBar && <SearchBar /> }
			<SocialChatMenu
				useZendesk={ useZendesk }
				useZoomChat={ useZoomChat }
				user={ user }
				support={ support }
			/>
			{ !hideNotifications && <SocialNotificationsMenu /> }
			<SocialUserMenu user={ user } />
		</div>
	</div>
);

RightMenuGroup.propTypes = {
	support: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	user: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	useZendesk: PropTypes.bool,
	useZoomChat: PropTypes.bool,
	hideSearchBar: PropTypes.bool,
	hideNotifications: PropTypes.bool,
};

RightMenuGroup.defaultProps = {
	support: {},
	user: {},
	useZendesk: false,
	useZoomChat: false,
	hideSearchBar: false,
	hideNotifications: false,
};

export default RightMenuGroup;



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/mainNav/components/RightNavMenuGroup.jsx